export default __webpack_public_path__ + "static/media/tomato-medley-barbecued-haloumi-skewers.f70b1698.jpg";